import { produce } from 'immer'
import {
  GET_YOUR_REPORT_TRANSACTIONS_FAILURE,
  GET_YOUR_REPORT_TRANSACTIONS_INIT,
  GET_YOUR_REPORT_TRANSACTIONS_SUCCESS,
  GetReportYourTransactionsActions,
} from 'src/redux/actions/data/transactions.actions'

export interface TransactionsSnapshotPaginatedDataState {
  ids: string[]
  loading: boolean
  complete: boolean
  totalItems?: number
}

export const initialState: TransactionsSnapshotPaginatedDataState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions = GetReportYourTransactionsActions

const TransactionsSnapshotPaginatedDataReducer = (
  state = initialState,
  action: Actions,
): TransactionsSnapshotPaginatedDataState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_YOUR_REPORT_TRANSACTIONS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_YOUR_REPORT_TRANSACTIONS_SUCCESS: {
        draft.loading = false
        draft.ids =
          action.payload.report.page === 1
            ? action.payload.report.transactions.map(
                (transaction) => transaction.id,
              )
            : [
                ...draft.ids,
                ...action.payload.report.transactions.map(
                  (transaction) => transaction.id,
                ),
              ]
        draft.complete = true
        draft.totalItems = action.payload.report.count
        return draft
      }

      case GET_YOUR_REPORT_TRANSACTIONS_FAILURE: {
        draft.loading = false
        draft.complete = true
        return draft
      }
    }
  })
}

export default TransactionsSnapshotPaginatedDataReducer
